type MultiSelectSpecProps = {
  multiSelection: string[] | null | undefined;
};

export function MultiSelectSpec({ multiSelection }: MultiSelectSpecProps) {
  if (!multiSelection) return null;

  return <div>You have selected {multiSelection.length} drawings</div>;
}
